import { isDefined, isNotDefined, isTruthyString } from '@togglecorp/fujs';

function prepareUrlParams(params) {
  return Object.keys(params).filter(k => isDefined(params[k])).map(k => {
    const param = params[k];
    if (isNotDefined(param)) {
      return undefined;
    }
    let val;
    if (Array.isArray(param)) {
      val = param.join(',');
    } else if (typeof param === 'number' || typeof param === 'boolean') {
      val = String(param);
    } else {
      val = param;
    }
    return `${encodeURIComponent(k)}=${encodeURIComponent(val)}`;
  }).filter(isDefined).join('&');
}
function isFetchable(url, method, body) {
  return isTruthyString(url) && (!['PUT', 'PATCH', 'POST'].includes(method) || isDefined(body));
}
function resolvePath(path, params) {
  if (isNotDefined(path)) {
    return '';
  }
  const resolvedUrl = path.replace(/{(\w+)}/g, (matchedText, matchedGroup) => {
    const value = params?.[matchedGroup];
    if (isNotDefined(value)) {
      // eslint-disable-next-line no-console
      console.error(`resolveUrlPath: value for key "${matchedGroup}" not provided in ${path}`);
      return matchedText;
    }
    return String(value);
  });
  return resolvedUrl;
}

export { isFetchable, prepareUrlParams, resolvePath };
//# sourceMappingURL=utils.js.map
